var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"buttons":['cancel'],"loading":_vm.loading,"large":"","title":"Listagem de residentes"}},[_c('rkm-alert',[_vm._v(" Verifique se os pacientes abaixo necessitam de atualização. ")]),_c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.items,"sort-by":"nome","hide-filters":"","hide-pagination":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }